<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData"></mainHead> -->
		<div class="pageTopBox space_between">
			<div class="titleText">应用数据</div>
			<div class="addBtn">
				<el-button type="primary" plain icon="el-icon-download" size="small" @click="appDataExport" v-hasPermi="['dataManage:appData:export']">导出应用信息</el-button>
			</div>
		</div>
		<div class="mianPage">
			<el-form inline class="el-form flex_start">
				<el-form-item label="日期">
					<el-date-picker v-model="datePicker" @change="datePickerChange" value-format="yyyy-MM-dd" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="媒体公司：">
					<el-select v-model="queryData.mediaCompany" filterable clearable size="small" style="width:210px">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="APPID/名称：">
					<el-select v-model="queryData.appId" filterable clearable size="small" style="width:210px">
						<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="OS：">
					<el-select v-model="queryData.os" clearable size="small" style="width:180px">
						<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<div class="menu-right flex_start">
					<el-radio-group v-model="dayCheck" @change="dayChange" size="small" style="margin-right: 20px;">
						<el-radio-button :label="1">今天</el-radio-button>
						<el-radio-button :label="2">昨天</el-radio-button>
					</el-radio-group>
					<el-button @click="searchReset" size="small" v-hasPermi="['dataManage:appData:query']">重置</el-button>
					<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['dataManage:appData:query']">查询</el-button>
				</div>
			</el-form>
			<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
				class="el_table" @sort-change="sortChangeFun"
				:header-cell-class-name="handleHeadAddClass" :row-style="changeRowBg">
				<!-- :summary-method="getSummaries" show-summary -->
				<el-table-column prop="recordTime" label="日期" width="120"></el-table-column>
				<el-table-column prop="companyName" label="媒体公司"></el-table-column>
				<el-table-column prop="" label="所属应用/ID" width="200">
					<template slot-scope="scope">
						<div style="cursor: pointer;" @click="adData(scope.row,scope.$index)" v-if="scope.row.mediaAppId">
							{{scope.row.mediaAppName}}/{{scope.row.mediaAppId}}</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<el-table-column prop="os" label="OS"></el-table-column>
				<el-table-column prop="pv" label="PV"></el-table-column>
				<el-table-column prop="uv" label="UV"></el-table-column>
				<el-table-column prop="reqNum" label="请求量"></el-table-column>
				<el-table-column prop="succNum" label="请求成功量" width="120" sortable="custom"></el-table-column>
				<el-table-column prop="succReqRate" label="请求成功率"></el-table-column>
				<el-table-column prop="showNum" label="展示量" width="120" sortable="custom"></el-table-column>
				<el-table-column prop="succShowRate" label="展示率"></el-table-column>
				<!-- <el-table-column prop="clickNum" label="点击量" width="110" sortable="custom"></el-table-column> -->
				<el-table-column prop="clickNum" label="未去重点击数" width="110" sortable="custom"></el-table-column>
				<el-table-column prop="uniqueClickNum" label="去重点击数"></el-table-column>
				<el-table-column prop="deductClickNum" label="扣量后点击数" width="120"></el-table-column>
				<el-table-column prop="clickRate" label="点击率"></el-table-column>
				<el-table-column prop="estimateProfit" label="预估收益" width="120"></el-table-column>
				<el-table-column prop="profitDiff" label="收益误差" width="120">
					<template slot-scope="scope">
						<div v-if="scope.row.profitDiff === null" style="color: #FF4D4F;">0</div>
						<div v-else>{{scope.row.profitDiff}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="ecpm" label="预估eCPM" width="150"></el-table-column>
				<!-- <el-table-column prop="" label="操作" width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="adData(scope.row,scope.$index)">广告数据</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '媒体管理',
				companyDrawerShow: false,
				dayCheck: 1,
				handleSelection: "", // 存储ID
				datePicker: [],
				osOptions: [], // OS下拉选择列表
				mediaAppOptions: [], // APP下拉选择列表
				adTypeSelectData: [],
				queryData: {},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				rulesApi: {
					companyName: [ //公司名称
						{
							required: true,
							message: '必填项，请输入',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在 1 到 50 个字符',
							trigger: 'blur'
						}
					],
					nickName: [ //公司地址
						{
							required: true,
							message: '请输入公司简称',
							trigger: 'blur'
						},
					],
				},
				companyFormData: {},
				channelTableDatas: [],
				dialogVisible: false, // 弹框显隐
				tHeaderColumnDataChecked: [],
				tHeaderColumnDataOption: [],

				expandedRows: [], // 记录展开的行

				sortField: {},
				orderBys: [],
				
				companyOptions: [], // 公司下拉选择列表
			}
		},
		mounted() {
			this.dateInit();
			this.getOSOption();
			this.getCompanyOption();
			this.getMediaAppOption();
			this.getTableData();
		},
		methods: {
			// 日期选择器初始化
			dateInit() {
				this.datePicker = []
				let currentDate = new Date();
				let year = currentDate.getFullYear();
				let month = String(currentDate.getMonth() + 1).padStart(2, '0');
				let day = String(currentDate.getDate()).padStart(2, '0');
				let formattedDate = `${year}-${month}-${day}`;
				this.datePicker.push(formattedDate);
				this.datePicker.push(formattedDate);
			},
			setYesterdayRange() {
				const today = new Date();
				const yesterdayStart = new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate() - 1
				);
				const yesterdayEnd = new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate() - 1
				);

				// 给 daterange 赋值
				this.datePicker = [
					this.formatDate(yesterdayStart),
					this.formatDate(yesterdayEnd),
				];
			},
			formatDate(date) {
				// 格式化日期为 yyyy-MM-dd
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, "0");
				const day = String(date.getDate()).padStart(2, "0");
				return `${year}-${month}-${day}`;
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption() {
				let res = await this.$http.get(this.$api.common.mediaAppOption);
				this.mediaAppOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.dataManage.appDataList, data);
				if (res.code == 1) {
					this.tableData = res.data.resp.list
					this.total = res.data.resp.totalRecord
					if(this.tableData.length>0){
						let obj = {
							recordTime: '合计',
							companyName: '-',
							os: '-',
							clickNum: res.data.click,
							uniqueClickNum: res.data.uniqueClickNum,
							deductClickNum: res.data.deductClickNum,
							succNum: res.data.succSum,
							succShowRate: res.data.succShowRate,
							clickRate: res.data.clickRate,
							ecpm: res.data.ecpm,
							estimateProfit: res.data.estimateProfit,
							// fillRate: res.data.fillRate,
							succReqRate: res.data.succReqRate,
							profitDiff: res.data.profitDiff,
							pv: res.data.pv,
							uv: res.data.uv,
							reqNum: res.data.reqNum,
							showNum: res.data.show,
						}
						this.tableData.unshift(obj)
					}
					// console.log(this.tableData)
					// this.$nextTick(() => {
					// 	this.showSummariesPosition()
					// })
				}
			},
			// 导出
			async appDataExport() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.dataManage.appDataExport, data, 1);
				const time = this.getTimeFun();
				this.$http.downloads(res, `${time}应用信息.xls`)
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			adData(row, index) {
				if(index==0){
					return
				}
				// console.log(row)
				this.$router.push({
					path: '/dataManage/dataShow',
					query: {
						sideId: 9,
						appId: row.mediaAppId,
						os: row.os
					}
				})
			},
			// 表头高亮保持
			handleHeadAddClass({
				column
			}) {
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			// 排序监听
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryData['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					// 填充率
					if (column.property == 'fillRate') {
						const values = data.map(item => Number(item['reqNum']));
						const valued = data.map(item => Number(item['reqNum']));
						let reqNum = 0
						let reqNums = 0
						reqNum = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						reqNums = valued.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] = Number(reqNum * 1) / Number(reqNums * 1)
						sums[index] = sums[index].toFixed(2);
						if (isNaN(sums[index])) {
							sums[index] = '0%'
						} else {
							sums[index] = sums[index] + '%'
						}
						return
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] += '';
					} else {
						sums[index] = '-';
					}
				});
				return sums;
			},
			changeRowBg({
				row,rowIndex
			}) {
				// console.log(row, 'hang');
				if (rowIndex == 0) { // 变颜色的条件
					return {
						background: "#F5F7FA" // 这个return的就是样式 可以是color 也可以是backgroundColor
					}
				}
			},
			/** 合计行设置 */
			showSummariesPosition() {
				// 合计行显示在表头
				let table = document.querySelector('.el-table')
				let footer = document.querySelector('.el-table__footer-wrapper')
				let body = document.querySelector('.el-table__body-wrapper')
				table.removeChild(footer)
				table.insertBefore(footer, body)
			},
			dayChange(e) {
				if (e == 1) {
					this.dateInit();
				} else {
					this.setYesterdayRange();
				}
				this.currentPage = 1
				this.getTableData();
			},
			// 日期选择事件
			datePickerChange(e) {
				this.dayCheck = -1
				this.currentPage = 1
				this.getTableData();
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		margin: 20px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 24px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}

	.menu-right {
		margin-left: auto;
		margin-bottom: 20px;
		align-items: center;
	}

	.setLabel {
		margin-left: 10px;
		font-size: 30px;
		cursor: pointer;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		padding-right: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}
</style>